<template>
  <div class="navbar-icon w-18 h-18 bg-primary-500">
    <img
      class="navbar-icon__img object-cover w-18 h-18"
      src="~/assets/images/onclusive-360-app-logo.svg"
      alt="Onclusive Logo"
    />
  </div>
</template>
